export default function SubmitButton(props) {
    return (
        <input className='btn btn-light-beige text-white' type={props.type} value={props.value} />
    )
}

export function SubmitButtonSpiner({ loading, btnValue }) {
    return (
        <button
            className='btn-masar btn-dark-orange text-white col-2 me-3 mb-3 position-absolute bottom-0 end-0'
            type="submit">
            {loading &&
                <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"></span>
            }
            {btnValue}
        </button>
    )
}
